<p-table
  #dt1
  [value]="data"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  [globalFilterFields]="['id', 'name', 'label']"
>
  <ng-template pTemplate="header">
    <tr>
      <th>
        <div class="flex justify-content-between align-items-center">
          Proces
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Operacija
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Ime i prezime
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Prva prijava
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">RN</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">Kod</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Količina
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">Rok</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">UVR</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">UVP</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">UVO</div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr [ngClass]="'status-' + data?.status">
      <td>
        <span>{{ data?.currentOperation }}</span>
      </td>
      <td>
        <span>{{ data?.currentSuboperation }}</span>
      </td>
      <td>
        <span>{{ data?.fullname }}</span>
      </td>
      <td>
        <span>{{ data?.startWorkTime }}</span>
      </td>
      <td>
        <span>
          <a [routerLink]="['/nip/edit/', data?.nip_id]">
            {{ data?.workOrderNum }}
          </a>
        </span>
      </td>
      <td>
        <span>
          {{ data?.productLabel }}
        </span>
      </td>
      <td>
        <span>{{ data?.availableProductAmount }}</span>
      </td>
      <td>
        <span>{{ data?.deadline }}</span>
      </td>
      <td>
        <span>{{ data?.totalWorkTime }}</span>
      </td>
      <td>
        <span>{{ data?.totalBreakTime }}</span>
      </td>
      <td>
        <span>{{ data?.totalLogoutTime }}</span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">Nema podataka.</td>
    </tr>
  </ng-template>
</p-table>
